export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a4fe6fb8834f50d4372afad94b90c49c.jpg"
          alt="Chef Ziad Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32 text-center">
        <div className="mb-6 sm:mb-8">
          <p className="text-[#C9A961] text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase font-light mb-3 sm:mb-4">
            Private Chef Services in London
          </p>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-white font-bold leading-tight mb-4 sm:mb-6">
            Chef Ziad Hafez
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/90 font-light mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
            Bringing 30+ Years of Culinary Excellence
            <br className="hidden sm:block" />
            <span className="block sm:inline"> to Your Special Occasions</span>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
          <a
            href="#contact"
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-[#C9A961] text-white rounded-lg text-sm sm:text-base font-medium tracking-wide transition-all hover:bg-[#B89851] hover:shadow-lg hover:shadow-[#C9A961]/30 whitespace-nowrap cursor-pointer text-center"
          >
            Book Your Experience
          </a>
          <a
            href="#about"
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg text-sm sm:text-base font-medium tracking-wide transition-all hover:bg-white/20 hover:border-white/50 whitespace-nowrap cursor-pointer text-center"
          >
            Discover More
          </a>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 max-w-4xl mx-auto px-4">
          <div className="text-center">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">30+</div>
            <div className="text-xs sm:text-sm text-white/80 font-light">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">1000+</div>
            <div className="text-xs sm:text-sm text-white/80 font-light">Events Catered</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">100%</div>
            <div className="text-xs sm:text-sm text-white/80 font-light">Client Satisfaction</div>
          </div>
          <div className="text-center col-span-2 lg:col-span-1">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-[#C9A961] mb-1 sm:mb-2">5★</div>
            <div className="text-xs sm:text-sm text-white/80 font-light">Rated Service</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#about" className="cursor-pointer">
          <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl"></i>
          </div>
        </a>
      </div>
    </section>
  );
}
